import { Partner } from "@expert/shared-types";
import { useMemo } from "react";

// Registry to configure a partner to display UI for selecting a single option for call intro questions
export const SINGLE_SELECT_PARTNERS: Partner[] = ["sparklightsales"];

export function useIsPartnerUsingSingleIntroQuestionResponse(partner: Partner): boolean {
    return useMemo(() => {
        return SINGLE_SELECT_PARTNERS.includes(partner);
    }, [partner]);
}
